import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { deleteDoc, doc } from "firebase/firestore";
import { db } from '../../Firebase';

// Redux slices
import { setgtMessage } from './../../redux/gtmsgSlice';
import { gtError } from './../../redux/gtstatusSlice';
import { startLoading, stopLoading } from './../../redux/loadingSlice';
import { setUser } from './../../redux/userSlice';

export const useDeleteuser = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate()

  const deleteUser = async (userId) => {
    try {
      dispatch(startLoading());

      // delete the user document by ID
      await deleteDoc(doc(db, "usersdetails", userId));

      dispatch(setUser(null)); // remove user from Redux state
      dispatch(gtError())
      dispatch(setgtMessage("User successfully deleted."));
      dispatch(stopLoading());
      navigate('/auth')
    } catch (err) {
      console.log("Delete user error:", err.message);
      dispatch(gtError());
      dispatch(setgtMessage(`${err.message}, could not delete user.`));
      dispatch(stopLoading());
    }
  };

  return { deleteUser };
};
